export type theme = {
  name: "dark" | "light";
  background: string;
  backgroundHover: string;
  backgroundSecondary: string;
  text: string;
  textSecondary: string;
  buttonText: string;
  placeholder: string;
  primary: string;
  primaryHover: string;
  secondary: string;
  secondaryHover: string;
  border: string;
  card: string;
  cardHover: string;
  tooltip: string;
  dangerBackground: string;
  dangerBorder: string;
  dangerText: string;
  backdrop: string;
  tint: "dark" | "light";
  notification: string;
  sky: { text: string; border: string; background: string };
  indigo: { text: string; border: string; background: string };
  emerald: { text: string; border: string; background: string };
  green: { text: string; border: string; background: string };
  amber: { text: string; border: string; background: string };
  yellow: { text: string; border: string; background: string };
  violet: { text: string; border: string; background: string };
  red: { text: string; border: string; background: string };
  slate: { text: string; border: string; background: string };
  rose: { text: string; border: string; background: string };
  purple: { text: string; border: string; background: string };
  blue: { text: string; border: string; background: string };
  gray: { text: string; border: string; background: string };
  teal: { text: string; border: string; background: string };
  cyan: { text: string; border: string; background: string };
  ruby: { text: string; border: string; background: string };
  // Semantic status colors
  todo: { text: string; border: string; background: string };
  complete: { text: string; border: string; background: string };
  pending: { text: string; border: string; background: string };
  attention: { text: string; border: string; background: string };
  neutral: { text: string; border: string; background: string };
};
export const themes: { light: theme; dark: theme } = {
  light: {
    name: "light",
    background: "#F2F2F7",
    // background: "#FFFFFF",
    backgroundHover: "#E6E6EC",
    backgroundSecondary: "#FFFFFF",
    // backgroundSecondary: "#F2F2F7",
    text: "#000000",
    textSecondary: "#687076",
    buttonText: "#000000",
    placeholder: "rgba(60,60,67,0.6)",
    primary: "#007AFF",
    primaryHover: "#005FCC",
    secondary: "#5856D6",
    secondaryHover: "#4443B6",
    border: "#bebfc7",
    card: "#f8f8fa",
    cardHover: "#F5F5F9",
    tooltip: "#F2F2F7",
    dangerBackground: "#FFCCCC",
    dangerBorder: "#CC0000",
    dangerText: "#990000",
    backdrop: "rgba(0,0,0,0.15)",
    tint: "light",
    sky: { text: "#1F1F1F", border: "#D1D5DB", background: "#E0F2FE" },
    indigo: { text: "#1E3A8A", border: "#C7D2FE", background: "#E0E7FF" },
    emerald: { text: "#065F46", border: "#BBF7D0", background: "#D1FAE5" },
    green: { text: "#BBF7D0", border: "#064E3B", background: "#238636" },
    amber: { text: "#92400E", border: "#FCD34D", background: "#FEF3C7" },
    yellow: { text: "#854D0E", border: "#FDE047", background: "#FEF9C3" },
    violet: { text: "#7C3AED", border: "#DDD6FE", background: "#EDE9FE" },
    red: { text: "#B91C1C", border: "#FCA5A5", background: "#FEE2E2" },
    slate: { text: "#0F172A", border: "#CBD5E1", background: "#F1F5F9" },
    rose: { text: "#9F1239", border: "#FDA4AF", background: "#FFE4E6" },
    purple: { text: "#ffffff", border: "#a855f7", background: "#a855f780" },
    blue: { text: "#ffffff", border: "#3b82f6", background: "#3b82f680" },
    gray: { text: "#ffffff", border: "#6b7280", background: "#6b728080" },
    teal: { text: "#115E59", border: "#5EEAD4", background: "#CCFBF1" },
    cyan: { text: "#164E63", border: "#67E8F9", background: "#CFFAFE" },
    ruby: { text: "#BE123C", border: "#FCA5A5", background: "#FEE2E2" },
    // Semantic status colors
    todo: { text: "#0C5A7A", border: "#00A5CF", background: "#E1F5FE" },
    complete: { text: "#1B5E45", border: "#4BBB90", background: "#E0F2EE" },
    pending: { text: "#8B5A00", border: "#FFA400", background: "#FFF3E0" },
    attention: { text: "#A30042", border: "#FF0769", background: "#FFE0EC" },
    neutral: { text: "#41464B", border: "#8A9099", background: "#EBEDEF" },
    notification: "#E53935",
  },
  dark: {
    name: "dark",
    background: "#000000",
    backgroundHover: "#1A1A1A",
    backgroundSecondary: "#101216",
    text: "#FFFFFF",
    textSecondary: "#9BA1A6",
    buttonText: "#FFFFFF",
    placeholder: "rgba(235,235,245,0.6)",
    primary: "#00A5CF",
    primaryHover: "#1ABAFB",
    secondary: "#5E5CE6",
    secondaryHover: "#3F3DC6",
    border: "#38383A",
    card: "#1C1C1E",
    cardHover: "#2A2A2D",
    tooltip: "#2C2C2E",
    dangerBackground: "#330000",
    dangerBorder: "#FF4C4C",
    dangerText: "#FF6B6B",
    backdrop: "rgba(0,0,0,0.3)",
    tint: "dark",
    sky: { text: "#E0F2FE", border: "#38BDF8", background: "#0C4A6E" },
    indigo: { text: "#C7D2FE", border: "#6366F1", background: "#1E3A8A" },
    emerald: { text: "#BBF7D0", border: "#10B981", background: "#064E3B" },
    green: { text: "#BBF7D0", border: "#064E3B", background: "#238636" },
    amber: { text: "#FCD34D", border: "#F59E0B", background: "#78350F" },
    yellow: { text: "#FDE047", border: "#EAB308", background: "#713F12" },
    violet: { text: "#DDD6FE", border: "#8B5CF6", background: "#4C1D95" },
    red: { text: "#FCA5A5", border: "#EF4444", background: "#7F1D1D" },
    slate: { text: "#CBD5E1", border: "#94A3B8", background: "#0F172A" },
    rose: { text: "#FDA4AF", border: "#F43F5E", background: "#881337" },
    purple: { text: "#ffffff", border: "#a855f7", background: "#a855f780" },
    blue: { text: "#ffffff", border: "#3b82f6", background: "#3b82f680" },
    gray: { text: "#ffffff", border: "#6b7280", background: "#6b728080" },
    teal: { text: "#CCFBF1", border: "#14B8A6", background: "#134E4A" },
    cyan: { text: "#CFFAFE", border: "#06B6D4", background: "#164E63" },
    ruby: { text: "#FCA5A5", border: "#EF4444", background: "#7F1D1D" },
    // Semantic status colors
    todo: { text: "#B3E5FC", border: "#00A5CF", background: "#0D3A5C" },
    complete: { text: "#A7E8D0", border: "#4BBB90", background: "#1A4A3A" },
    pending: { text: "#FFD180", border: "#FFA400", background: "#5C3D00" },
    attention: { text: "#FF80B4", border: "#FF0769", background: "#5C0227" },
    neutral: { text: "#C5CACC", border: "#41464B", background: "#1F2225" },
    notification: "#FF6B6B",
  },
};
